import { NgModule } from '@angular/core';

import { RatingShapeComponent } from "./rating-shape.component";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [CommonModule],
    declarations: [RatingShapeComponent],
    exports: [RatingShapeComponent],
})
export class RatingShapeModule {
}
